<template>
  <div class="d-flex justify-content-center">
    <div class="position-relative">
      <input
        type="text"
        class="find-input"
        v-model="localValue"
        placeholder="発行コード"
        @keyup.enter="onSubmit"
      />
    </div>
    <button class="bg-transparent border-0" @click="onSubmit">
      <img
        src="@/assets/acrypro/search.svg"
        style="width: 35px; height: 35px"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: "TicketCodeLookupForm",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  watch: {
    value(val) {
      this.localValue = val;
    },
    localValue(val) {
      this.$emit("input", val);
    },
  },
  methods: {
    onSubmit() {
      this.$emit("search", this.localValue);
    },
  },
};
</script>

<style scoped lang="scss">
.find-input {
  width: 285px;
  height: 48px;
  border: $primary-main-color solid 1px;
  border-radius: 100px;
  background-color: transparent;
  padding: 0px 16px;
}
</style>
